import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'
import { LicenseRequestData } from '../license.interfaces'

async function requestLicense(license: LicenseRequestData) {
  return requests.post(`${LicenseEndpoints.LICENSE}/request`, license)
}

export default requestLicense
